import { render, staticRenderFns } from "./case.vue?vue&type=template&id=2c024d4f&scoped=true"
import script from "./case.vue?vue&type=script&lang=js"
export * from "./case.vue?vue&type=script&lang=js"
import style0 from "./case.vue?vue&type=style&index=0&id=2c024d4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c024d4f",
  null
  
)

export default component.exports